var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudyDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g1926",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1932",
    d: "M0-682.665H28v28H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1930",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1936",
    transform: "translate(26.086 11.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1938",
    d: "M0,0H1.094",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1940",
    transform: "translate(24.914 6.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1942",
    d: "M0-12.786l.947-.547",
    transform: "translate(0 13.333)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1944",
    transform: "translate(21.711 3.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1946",
    d: "M0-22.146l.547-.947",
    transform: "translate(0 23.093)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g1948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1950",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1956",
    transform: "translate(17.336 1.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1958",
    d: "M0-25.573v-1.094",
    transform: "translate(0 26.667)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g1960",
    transform: "translate(12.414 3.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1962",
    d: "M-12.786-22.146l-.547-.947",
    transform: "translate(13.333 23.093)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g1964",
    transform: "translate(8.811 6.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1966",
    d: "M-22.147-12.786l-.947-.547",
    transform: "translate(23.095 13.333)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g1968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1970",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1976",
    transform: "translate(24.914 16.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1978",
    d: "M-22.147-12.786l-.947-.547",
    transform: "translate(23.095 13.333)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1980",
    transform: "translate(11.897 6.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1982",
    d: "M-162.381-250.815a5.471,5.471,0,0,0,3.963-5.259,5.469,5.469,0,0,0-5.469-5.469,5.469,5.469,0,0,0-5.439,4.895",
    transform: "translate(169.326 261.542)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1984",
    transform: "translate(0.82 10.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1986",
    d: "M-89.5-358.02a3.828,3.828,0,0,1-3.828-3.828,3.826,3.826,0,0,1,3.741-3.824,5.444,5.444,0,0,1-.46-2.192,5.469,5.469,0,0,1,5.469-5.469,5.464,5.464,0,0,1,5.451,5.119,3.268,3.268,0,0,1,1.111-.2,3.281,3.281,0,0,1,3.281,3.281,3.289,3.289,0,0,1-.05.549l.05,0a3.281,3.281,0,0,1,3.281,3.281,3.281,3.281,0,0,1-3.281,3.281Z",
    transform: "translate(93.333 373.332)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudyDay);
export default __webpack_public_path__ + "static/media/cloudy-day.a1e93315714316d3021e851cc8c60735.svg";
export { ForwardRef as ReactComponent };